<template>
    <BaseCard
        v-editable="tradeShow.vEditable"
        :card="tradeShow"
        content-classes="p-0"
    >
        <template #title>
            <div class="rounded-t-lg bg-light-blue">
                <div class="flex flex-col gap-2 py-10 text-center">
                    <h3>{{ month }}</h3>
                    <div class="font-accent text-[64px] leading-none">
                        {{ days }}
                    </div>
                    <div class="text-[30px]">{{ year }}</div>
                </div>
            </div>
        </template>
        <template #subtitle>
            <span class="hidden"></span>
        </template>
        <template #footer>
            <div class="mt-2 flex flex-col gap-3 px-6 pb-10">
                <div class="text-base text-drip">
                    {{ tradeShow.location }}
                </div>
                <div class="text-[20px] font-bold text-grind">
                    {{ tradeShow.title }}
                </div>
                <div
                    v-if="tradeShow.shortDescription"
                    class="text-base text-grind"
                >
                    {{ tradeShow.shortDescription }}
                </div>
                <a
                    v-if="tradeShow.link && tradeShow.link.url"
                    :href="urlFromStoryblokLinkField(tradeShow.link)"
                    target="_blank"
                >
                    <div class="flex items-center gap-2">
                        Trade show website
                        <Icon name="arrow-up-right-from-square-solid" />
                    </div>
                </a>
            </div>
        </template>
    </BaseCard>
</template>

<script setup lang="ts">
import type { TradeShowType } from '#shared/types/TradeShowType';
import BaseCard from '~/components/ui/BaseCard.vue';
import useDateSplitter from '~/composables/useDateSplitter';
import { urlFromStoryblokLinkField } from '~/utils/helpers';

const props = defineProps<{
    tradeShow: TradeShowType;
}>();

const { getDay, getMonth, getYear } = useDateSplitter();

const days = computed(() => {
    const startDay = getDay(props.tradeShow.startDate);
    const endDay = getDay(props.tradeShow.endDate);
    if (!props.tradeShow.endDate || startDay === endDay) {
        return startDay;
    } else {
        return startDay + ' - ' + endDay;
    }
});
const month = computed(() => {
    const startMonth = getMonth(props.tradeShow.startDate);
    const endMonth = getMonth(props.tradeShow.endDate);
    if (startMonth !== endMonth) {
        return startMonth + ' - ' + endMonth;
    }
    return startMonth;
});
const year = computed(() => {
    const startYear = getYear(props.tradeShow.startDate);
    const endYear = getYear(props.tradeShow.endDate);
    if (startYear !== endYear) {
        return startYear + ' - ' + endYear;
    }
    return startYear;
});
</script>
